module.exports = ".row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n.row{\r\n    padding:9px 0px 0px !important;\r\n}\r\n\r\n.error-msg{\r\n    margin-top:-4px;\r\n}\r\n\r\n.input-group label{\r\n    width:100%;\r\n}\r\n\r\n.input-group{\r\n    margin-top: 5px;\r\n    border-radius: 5px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module id = ./src/app/ultilities/roles/roles-form/roles-form.component.css
// module chunks = main